import InlineBtn from "components/shared/inlineBtn";
import React from "react";

const ScenarioButtons = (props) => {
    return props.editMode ? (
        <div className="d-flex justify-content-end">
            <InlineBtn value="Отмена" action={props.toggleEditMode} />
            <InlineBtn value="Сохранить" action={props.saveItem} />
        </div>
    ) : (
        <div className="d-flex justify-content-between">
            {props.removeItem ? (
                <InlineBtn value={props.type === "scenario" ? "В архив" : "Удалить"} action={props.removeItem} />
            ) : (
                <div />
            )}
            <div className="justify-content-end">
                {props.createCopy && <InlineBtn value="Создать копию" action={props.createCopy} />}
                <InlineBtn value="Изменить" action={props.toggleEditMode} />
            </div>
        </div>
    );
};

export default ScenarioButtons;
